export const tableColumns = [
  {
    key: 'accountType',
    title: '账户类型',
    scopedSlots: { customRender: 'accountTypeSlot' },
    width: 120
  },
  {
    key: 'bankName',
    title: '银行名称',
    dataIndex: 'bankName',
    width: 200
  },
  {
    key: 'accountName',
    title: '账号名称',
    dataIndex: 'accountName',
    width: 150
  },
  // accountNo
  {
    key: 'accountNo',
    title: '账号ID',
    dataIndex: 'accountNo',
    width: 150
  },
  // {
  //   key: 'bankCardNumber',
  //   title: '账号',
  //   dataIndex: 'bankCardNumber',
  //   width: 200,
  //   customRender: (text) => {
  //     if (!text) return '-'
  //     // 对于银行卡号进行脱敏处理
  //     if (text.length > 8) {
  //       return text.substring(0, 4) + '****' + text.substring(text.length - 4)
  //     }
  //     return text
  //   }
  // },
  // {
  //   key: 'openProvince',
  //   title: '开户地区',
  //   dataIndex: 'openProvince',
  //   width: 150,
  //   customRender: (text, record) => {
  //     if (record.accountType === 'bank' && text && record.openCity) {
  //       return `${text} ${record.openCity}`
  //     }
  //     return text || '-'
  //   }
  // },
  {
    key: 'ifscCode',
    title: 'IFSC Code',
    dataIndex: 'ifscCode',
    width: 150
  },
  {
    key: 'payeeName',
    title: '收款人姓名',
    dataIndex: 'payeeName',
    width: 150
  },
  {
    key: 'mchNo',
    title: '商户ID',
    dataIndex: 'mchNo',
    width: 150
  },
  {
    key: 'isDefault',
    title: '默认账户',
    dataIndex: 'isDefault',
    width: 100,
    customRender: (text) => {
      return text === 1 ? '是' : '否'
    }
  },
  // {
  //   key: 'status',
  //   title: '状态',
  //   scopedSlots: { customRender: 'statusSlot' },
  //   width: 100
  // },
  {
    key: 'createdAt',
    title: '创建时间',
    dataIndex: 'createdAt',
    scopedSlots: { customRender: 'createdAtSlot' },
    width: 180
  },
  {
    key: 'op',
    title: '操作',
    scopedSlots: { customRender: 'opSlot' },
    width: 150,
    fixed: 'right'
  }
]

// 账户类型映射
export const ACCOUNT_TYPE_MAP = {
  1: { text: '银行账户', color: 'blue' },
  2: { text: 'USDT账户', color: 'green' }
  // other: { text: '支付账户', color: 'orange' }
}

// 网络类型选项
export const NETWORK_TYPE_OPTIONS = [
  { value: 'TRC20', label: 'TRC20' },
  { value: 'ERC20', label: 'ERC20' },
  { value: 'BEP20', label: 'BEP20' }
]

// 支付平台选项
export const PAYMENT_PLATFORM_OPTIONS = [
  { value: 'alipay', label: '支付宝' },
  { value: 'wechat', label: '微信支付' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'other', label: '其他' }
]

// 获取账户类型文本
export const getAccountTypeText = (type) => {
  console.log('type', type)
  return ACCOUNT_TYPE_MAP[type]?.text || '未知'
}

// 获取账户类型颜色
export const getAccountTypeColor = (type) => {
  return ACCOUNT_TYPE_MAP[type]?.color || 'default'
}
